import { render, staticRenderFns } from "./FormBankAccounts.vue?vue&type=template&id=9c0e9966&"
import script from "./FormBankAccounts.vue?vue&type=script&lang=js&"
export * from "./FormBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports